import { useTranslation } from "react-i18next";
import { Page } from "../../../../components/Page";
import { WithAuthorization } from "../../../../context";
import { Center, Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { CountrySelector } from "../index";
import { Card } from "../../../../components/Card";
import ukFlag from "../../../../assets/flags/gb.png";
import germanyFlag from "../../../../assets/flags/de.png";
import franceFlag from "../../../../assets/flags/fr.png";
import euFlag from "../../../../assets/flags/eu.png";
import usaFlag from "../../../../assets/flags/us.png";
import { euData, franceData, germanyData, ukData, usaData } from "./components/helpers";
import { useState } from "react";
import {
  ClimatePolicyRadarDescription,
  ClimatePolicyRadarLegislations,
  ClimatePolicyRadarPolicies
} from "./components";

function ClimatePolicyRadar() {
  const countryOptions = [
    { name: "UK", flag: ukFlag, data: ukData },
    { name: "Germany", flag: germanyFlag, data: germanyData },
    { name: "France", flag: franceFlag, data: franceData },
    { name: "EU", flag: euFlag, data: euData },
    { name: "USA", flag: usaFlag, data: usaData }
  ];
  const { t } = useTranslation("translation", {
    keyPrefix: "climatePolicyRadar"
  });
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedCountry, setSelectedCountry] = useState(countryOptions[0]);

  const handleCountryChange = (value) => {
    setSelectedCountry(countryOptions.find(el => el.name === value));
  };

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Flex justifyContent="center" marginTop={5}>
        <CountrySelector
          data={countryOptions}
          selectedValue={selectedCountry}
          handleCountryChange={handleCountryChange}
        />
      </Flex>
      <Card marginBlockStart={5}>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} overflow="auto">
          <Center>
            <TabList borderBottom="none" overflow="auto">
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.description")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.policies")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.legislations")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <ClimatePolicyRadarDescription />
            </TabPanel>
            <TabPanel padding="0">
              <ClimatePolicyRadarPolicies
                data={selectedCountry.data.policies}
                source={selectedCountry.data.policiesSource}
              />
            </TabPanel>
            <TabPanel padding="0">
              <ClimatePolicyRadarLegislations
                data={selectedCountry.data.legislations}
                source={selectedCountry.data.legislationsSource}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(ClimatePolicyRadar);